import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeUpdateProtectResourcesModel extends BaseOperationModel {
  learningEnd: Date;
}
